// src/components/ToolView.js
import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getVisibleTools } from '../data/buddyTools';
import ToolContainer from './ToolContainer';

const ToolView = () => {
  const { toolPath } = useParams();
  const navigate = useNavigate();
  const tool = getVisibleTools().find(t => t.path === toolPath);

  useEffect(() => {
    if (!tool) {
      navigate('/home?invalid-tool=true', { replace: true });
    }
  }, [tool, navigate]);

  if (!tool) {
    // Render nothing while redirecting
    return null;
  }

  return <ToolContainer tool={tool} />;
};

export default ToolView;
